import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexEndOfEmployments from "./endOfEmployments/IndexEndOfEmployments";
import IndexReasons from "./settings/reasons/IndexReasons";
import IndexChecklists from "./settings/checklists/IndexChecklists";
import IndexQuestions from "./settings/questions/IndexQuestions";
import { guardElement } from "@comps/components";

const EndOfEmploymentsModules = () => {
  return (
    <Routes>
      <Route path="end-of-employment/index" element={ guardElement(<IndexEndOfEmployments modkey="endOfEmployment"/>, "endOfEmployment") } />
      <Route path="settings/reasons" element={ guardElement(<IndexReasons modkey="eoeReasons"/>, "eoeReasons") } />
      <Route path="settings/checklist" element={ guardElement(<IndexChecklists modkey="eoeChecklist"/>, "eoeChecklist") } />
      <Route path="settings/questions" element={ guardElement(<IndexQuestions modkey="eoeQuestions" />, "eoeQuestions") } />

    </Routes>
  );
}

export default EndOfEmploymentsModules;
